import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import membershipLevel from '../customApp/redux/membershipLevel/sagas';
import cms from '../customApp/redux/cms/sagas';
import downloadCenter from '../customApp/redux/downloadCenter/sagas';
import book from '../customApp/redux/book/sagas';
import memberPoint from '../customApp/redux/memberPoint/sagas';
import memberTicket from '../customApp/redux/memberTicket/sagas';
import memberFilter from '../customApp/redux/memberFilter/sagas';
import brand from '../customApp/redux/brand/sagas';
import address from '../customApp/redux/address/sagas';
import product from '../customApp/redux/product/sagas';
import member from '../customApp/redux/member/sagas';
import memberList from '../customApp/redux/memberList/sagas';
import pickupActivity from '../customApp/redux/pickupActivity/sagas';
import memberCampaign from '../customApp/redux/memberCampaign/sagas';
import memberTransaction from '../customApp/redux/memberTransaction/sagas';
import regular from '../customApp/redux/regular/sagas';
import codeGenerator from '../customApp/redux/codeGenerator/sagas';
import memberCard from '../customApp/redux/memberCard/sagas';
import menu from '../customApp/redux/menu/sagas';
import briefTerm from '../customApp/redux/briefTerm/sagas';
import sms from '../customApp/redux/sms/sagas';
import inbox from '../customApp/redux/inbox/sagas';
import push from '../customApp/redux/push/sagas';
import permission from '../customApp/redux/permission/sagas';
import synchronizedUploadTransaction from '../customApp/redux/synchronizedUploadTransaction/sagas';
import relay from '../customApp/redux/relay/sagas';
import payment from '../customApp/redux/payment/sagas';
import mobileAppConfiguration from '../customApp/redux/mobileAppConfiguration/sagas';
import clientAppKey from '../customApp/redux/clientAppKey/sagas';
import mission from '../customApp/redux/mission/sagas';
import eventNotification from '../customApp/redux/eventNotification/sagas';
import linkBlockAppDeepLink from '../customApp/redux/linkBlockAppDeepLink/sagas';
import tag from '../customApp/redux/tag/sagas';
import sale from '../customApp/redux/sale/sagas';
import voucher from '../customApp/redux/voucher/sagas';
import voucherBox from '../customApp/redux/voucherBox/sagas';
import externalCodeGenerator from '../customApp/redux/externalCodeGenerator/sagas';
import receipt from '../customApp/redux/receipt/sagas';
import subscription from '../customApp/redux/subscription/sagas';
import shop from '../customApp/redux/shop/sagas';
import memberTagFilter from '../customApp/redux/memberTagFilter/sagas';
import logistic from '../customApp/redux/logistic/sagas';
import homeDeliveryOrder from '../customApp/redux/homeDeliveryOrder/sagas';
import statisticsDataReport from '../customApp/redux/statisticsDataReport/sagas';
import general from '../customApp/redux/general/sagas';
import externalTicket from '../customApp/redux/externalTicket/sagas';
import thirdPartyOrder from '../customApp/redux/thirdPartyOrder/sagas';
import productBatchCode from '../customApp/redux/productBatchCode/sagas';

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    membershipLevel(),
    cms(),
    downloadCenter(),
    book(),
    memberPoint(),
    memberTicket(),
    memberFilter(),
    brand(),
    address(),
    product(),
    member(),
    memberList(),
    pickupActivity(),
    memberCampaign(),
    memberTransaction(),
    regular(),
    codeGenerator(),
    memberCard(),
    menu(),
    briefTerm(),
    sms(),
    inbox(),
    push(),
    permission(),
    synchronizedUploadTransaction(),
    relay(),
    payment(),
    mobileAppConfiguration(),
    clientAppKey(),
    mission(),
    eventNotification(),
    linkBlockAppDeepLink(),
    tag(),
    sale(),
    voucher(),
    voucherBox(),
    externalCodeGenerator(),
    receipt(),
    subscription(),
    shop(),
    memberTagFilter(),
    logistic(),
    homeDeliveryOrder(),
    statisticsDataReport(),
    general(),
    externalTicket(),
    thirdPartyOrder(),
    productBatchCode(),
  ]);
}
